import React, { useEffect, useState } from "react";
import { Form, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import * as CityApi from "../../../api/DivisionsCitiesAPI";
import * as RrbApi from "../../../api/RrbAPI";
import { handleApiError } from "../../../common/errorHandler";
import CustomModal from "../../../components/CustomModal/CustomModal";
import { FormField, FormFieldSelect } from "../../../components/Form/FormField";

import { useDispatch, useSelector } from "react-redux";
import { toggleShouldUpdate } from "../../../store/slices/sideBar/sidebarCounterSlice";
import { yupResolver } from "@hookform/resolvers/yup";
import { CitySchema } from "./CitySchema";
import { STATES } from "../../../common/constants";

const AddEditCities = ({ cityModal, resetCityModal }) => {
  const authSelector = useSelector((state) => state.rrb.authUserReducer);
  const UserRole = authSelector.role.slug;
  const { show, title, saveBtnText, action, id } = cityModal;
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const handleToggleUpdate = () => {
    dispatch(toggleShouldUpdate());
  };
  const [rrbList, setRrbList] = useState([]);

  const STATUS = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ];

  const defaulCityValue = {
    city: "",
    // status: "",
    state: "",
  };
  const {
    register,
    handleSubmit,
    formState: { errors: cityError },
    setError,
    control,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(CitySchema(UserRole)),
    defaultValues: defaulCityValue,
  });
  const rrb = watch("rrb");

  const formSubmit = async (formData) => {
    setIsLoading(true);
    try {
      console.log(formData);
      let requestPromise;
      let successMessage;
      // const refinedFormData = { ...formData, division_id: null }

      if (action === "EDIT") {
        console.log("action === edit");
        requestPromise = CityApi.update(id, formData);
        successMessage = "City updated successfully.";
      } else {
        requestPromise = CityApi.create(formData);
        successMessage = "City added successfully.";
      }

      await requestPromise.then((res) => {
        resetCityModal(true);
        toast.success(successMessage);
      });
    } catch (error) {
      handleApiError(error, setError);
    } finally {
      setIsLoading(false);
      handleToggleUpdate();
    }
  };

  const fetchCity = async () => {
    setIsLoading(true);
    try {
      const response = await CityApi.getDivisionCityById(id);
      const data = response?.data;
      if (data) {
        let { city, status, state } = data.divisionCity[0];
        setValue("city", city);
        setValue("state", state);
        setValue(
          "status",
          STATUS.find((option) => option.value === status)
        );
        setValue(
          "state",
          STATES.find((option) => option.value === state)
        );
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchCity();
    }
  }, []);
  useEffect(() => {
    RrbApi.getAll().then((res) => {
      setRrbList(res.data.records);
    });

    // if(cityModal?.rrb){
    //   setValue('rrb', {
    //     label: cityModal?.rrb?.rrb_full_name,
    //     value: cityModal?.rrb?.id,
    //   });
    // }
  }, []);

  useEffect(() => {
    if (cityModal?.rrb) {
      const selectedRrb = rrbList.find((r) => r.id == cityModal.rrb.id);
      console.log(selectedRrb);
      setValue("rrb", {
        label: selectedRrb?.rrb_full_name,
        value: selectedRrb?.id,
      });
    }
    if (cityModal?.state) {
      setValue("state", {
        label: cityModal?.state,
        value: cityModal?.state,
      });
    }
  }, [rrbList]);
  return (
    <CustomModal
      show={show}
      isLoading={isLoading}
      onHide={() => resetCityModal(false)}
      modalHeading={title}
      size='md'
      saveBtnText={saveBtnText}
      onSaveCallback={handleSubmit(formSubmit)}
      hadBodyPadding
    >
      <Form onSubmit={handleSubmit(formSubmit)} autoComplete='off'>
        <Modal.Body className='pb-0'>
          <Row className='row-cards'>
            {UserRole == "control-admin" && (
              <FormFieldSelect
                label='Recruitment Boards'
                name='rrb'
                control={control}
                options={rrbList.map((rrb) => ({
                  label: rrb.rrb_full_name,
                  value: rrb.id,
                }))}
                error={cityError?.rrb?.value}
                required
                size='12'
              />
            )}
            <FormField
              label='City'
              name='city'
              type='text'
              error={cityError?.name}
              register={register}
              placeholder='Enter City'
              autoFocus
              required
              size='12'
            />
            <FormFieldSelect
              label='State'
              name='state'
              control={control}
              error={cityError?.state?.value} // ✅ Correctly access the error
              register={register}
              placeholder='Enter State'
              // autoFocus
              options={STATES}
              isSearchable
              required
              size='12'
            />
            {/* <FormFieldSelect
              label="Status"
              name="status"
              isSearchable
              control={control}
              options={STATUS}
              error={cityError?.status}
              required
              size="12"
            /> */}
          </Row>
        </Modal.Body>
      </Form>
    </CustomModal>
  );
};

export default AddEditCities;
